import {
  ADD_ATTENDEES,
  ADD_ATTENDEES_SUCCESS,
  ADD_ATTENDEES_FAILED,
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILED,
  CLEAR,
} from './constants';

export const addAttendeesAction = (deedId, users, emails, roles) => ({
  type: ADD_ATTENDEES,
  deedId,
  users,
  emails,
  roles,
});
export const addAttendeesSuccessAction = () => ({
  type: ADD_ATTENDEES_SUCCESS,
});
export const addAttendeesFailedAction = (error, errorCode) => ({
  type: ADD_ATTENDEES_FAILED,
  error,
  errorCode,
});

export const searchAction = (term) => ({
  type: SEARCH,
  term,
});
export const searchSuccessAction = (results) => ({
  type: SEARCH_SUCCESS,
  results,
});
export const searchFailedAction = (error, errorCode) => ({
  type: SEARCH_FAILED,
  error,
  errorCode,
});

export const clearAction = () => ({
  type: CLEAR,
});
